export default __webpack_public_path__ + "static/media/blog3.969725e8.svg";